
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ExameType, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class ExameTypeEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    exameType: ExameType;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getExameType()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getExameType(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.exameType = data;
                this.onDataChanged.next(this.exameType);
                resolve(this.exameType);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('exameType/' + this.routeParams.id).subscribe({next:(res: ExameType ) => {
                    this.exameType = res;
                    this.onDataChanged.next(this.exameType);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(exameType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('exameType/', exameType).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(exameType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('exameType/', exameType).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(exameType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('exameType/' + exameType.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): ExameType {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
